import styled from 'styled-components';
import IconThumbsDownOutline from './IconThumbsDownOutline';
var IconThumbsUpOutline = /*#__PURE__*/styled(IconThumbsDownOutline).withConfig({
  displayName: "IconThumbsUpOutline",
  componentId: "c11n-8-109-1__sc-y37b8x-0"
})(["transform:scaleY(-1);"]);
export default IconThumbsUpOutline;